import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetOrderFraudControlList = () =>
    request({
        url: ApiURL.Query.GetOrderFraudControl,
        method: RequestType.GET,
        //params:params,
    });
const SetFraudPaymentNotificationStatus = (data: any) =>
    request({
        url: ApiURL.Query.SetFraudPaymentNotificationStatus,
        method: RequestType.POST,
        data: data,
    });
const OrderFraudListQuery = {
    GetOrderFraudControlList,
    SetFraudPaymentNotificationStatus,
};

export default OrderFraudListQuery;
